export default __webpack_public_path__ + "double-quotes.svg?590cb0194c3a8ae48792104e90a03df5";